/**
 * Helper method to turn a number into an excel style column header. In Excel (or most spreadsheet software) the column headers are alpha
 * characters. Column 1 being A, 2 being B, 3 being C, etc. Once the entire alphabet is done it doubles up, so AA, AB, AC, etc.
 *
 * This function converts a numeric value to the corresponding alpha representation of a column.
 */
export const convertToBase26Alpha = (n: number, isCapital = true): string => {
    const num = n + 1;
    const quotient = Math.floor(num / 26) - 1;
    const remainder = num % 26;
    if (quotient < 0 || (quotient === 0 && remainder === 0)) {
        let character = String.fromCharCode(96 + num);

        if (isCapital) {
            character = character.toUpperCase();
        }

        return character;
    }

    return convertToBase26Alpha(quotient) + convertToBase26Alpha(remainder - 1);
};
